import { Text } from '@grammarly/design-system'
import classes from './LoadingText.module.scss'

export interface LoadingTextWithoutDotProps {
  readonly text: string
}

/**
 * Component for rendering an animated piece of text
 * Unlike LoadingText, this component does not have steps and a dot at the end
 */
export const LoadingTextWithoutDot = ({ text }: LoadingTextWithoutDotProps) => {
  return (
    <div className={classes.root}>
      <Text className={classes.text} as={'span'} variant={'text-small'}>
        {text}
      </Text>
    </div>
  )
}
